import { User } from "@/entities/user/user"

export function createUsersById(users: User[] | undefined): Map<string, User> {
   const usersById = new Map<string, User>()
   if (!users) return usersById

   for (const user of users) {
      usersById.set(user.id, user)
   }

   return usersById
}
